'use client'

import Link from 'next/link'
import OutlineButton from '@/components/Common/Button/OutlineButton'
import { useTranslation } from 'react-i18next'

export default function NotFound() {
  const { t } = useTranslation('common')
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-5 bg-alternative px-4 text-center">
      <div className="p-5">
        <img src="/svg/icon_talk.svg" alt="talk" className="h-10 w-10" />
      </div>
      <div className="flex flex-col items-center justify-center gap-2">
        <div className="text-lg font-bold text-label-normal">{t('notFound.title')}</div>
        <div className="hidden text-sm leading-6 text-alternative md:block">
          {t('notFound.descDesktop')}
        </div>
        <div className="block text-sm leading-6 text-alternative md:hidden">
          {t('notFound.descMobileLine1')}
          <br />
          {t('notFound.descMobileLine2')}
        </div>
      </div>
      <Link href="/">
        <OutlineButton size="lg" variant="assistive">
          {t('notFound.goHome')}
        </OutlineButton>
      </Link>
    </div>
  )
}
